<template>
  <layout-popup width="428">
    <v-progress-linear :active="!isDone" indeterminate absolute top />
    <template slot="header">
      RPC reports
    </template>
    <template>
      <div class="mx-4">
        <div style="max-height: 250px;">
          <v-list v-if="linkedReports.value.length">
            <v-hover
              v-slot:default="{ hover }"
              :key="item.id"
              v-for="item in linkedReports.value"
            >
              <v-list-item class="px-5">
                <v-list-item-content class="pt-0">
                  <v-list-item-title class="text-wrap">
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ convertDate(item.createdAt) }}, error: {{ item.error }},
                    done: {{ item.done }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-hover>
          </v-list>
          <div v-else class="pa-3">
            No reports yet
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <v-spacer />
      <v-btn text @click="$emit('close')">
        close
      </v-btn>
    </template>
  </layout-popup>
</template>

<script>
import LayoutPopup from '@/layouts/LayoutPopup.vue';
import { computed, reactive, watch } from '@vue/composition-api';
import { toReactive } from '@vueuse/core';
import convertDate from '../../utils/convertDate';

export default {
  name: 'RpcTrackModal',
  methods: { convertDate },
  components: { LayoutPopup },
  props: {
    linkedReports: {
      type: Object,
      default: () => ({ value: [] })
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      progress: 0,
      loaderType: 'determinate',
      isError: false,
      action: 'Process started...'
    });

    const isDone = computed(() =>
      props.linkedReports.value.some(item => item.done)
    );

    return {
      ...toReactive(state),
      isDone
    };
  }
};
</script>
